<template>
  <article class="step-two" >

    <button class="button blue-border back"
      @click="$emit('back', 1)"
    >
      Back to all Memberships
    </button>

    <p class="step-title">Choose Term</p>

    <div class="terms-wrap">

      <div class="flex">

        <div class="term"
          v-for="term of terms"
          @click="selectTerm(term)"
        >
          <p class="title">{{ term.title }}</p>
          <p class="offer" v-if="term.offer">{{ term.offer }}</p>

          <div class="prices">
            <div class="form-field radio" v-if="term.weekly_cost !== '0.00' && term.weekly_cost">
              <label>
                <input type="radio" :value="term.weekly_cost" v-model="offer_type">
                <span>${{ term.weekly_cost }} <i>/ week</i></span>
              </label>
            </div>
            <div class="form-field radio" v-if="term.monthly_cost !== '0.00' && term.monthly_cost">
              <label>
                <input type="radio" :value="term.monthly_cost" v-model="offer_type">
                <span>${{ term.monthly_cost }} <i>/ month</i></span>
              </label>
            </div>
          </div>
        </div>

      </div>

      <div class="bottom flex flex-between">
        <p>{{ term_terms }}</p>
        <button class="button light-blue" @click="finishStepTwo" :disabled='offer_type === null'>Next</button>
      </div>

    </div>

  </article>
</template>

<script>
export default {
  props: {
    terms: Array,
    term_terms: String
  },
  data () {
    return {
      offer_type: null,
      term: {},
      termss: [
        {
          title: '24 Months',
          offer: 'BEST OFFER',
          price: [
            { id: 22, amount: 24.50, duration: 'Week' },
            { id: 23, amount: 106.17, duration: 'Month' }
          ]
        },
        {
          title: '12 Months',
          offer: '',
          price: [
            { id: 32, amount: 27.00, duration: 'Week' },
            { id: 33, amount: 107.00, duration: 'Month' }
          ]
        },
        {
          title: '6 Months',
          offer: '',
          price: [
            { id: 42, amount: 29.50, duration: 'Week' },
          ]
        },
        {
          title: 'No Contract',
          offer: '',
          price: [
            { id: 52, amount: 39.50, duration: 'Week' },
          ]
        }
      ]
    };
  },
  methods: {
    selectTerm (term) {
      console.log(term)
      this.term = term
    },

    finishStepTwo () {
      this.$emit('termType', this.term, this.offer_type)
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/memberships/StepTwo.vue